<script setup lang="ts">
import { formatTelefonNumber } from '@/helpers/tools'
import KpTextfield from '@/components/kp-textfield.vue'

const { modelValue = null } = defineProps<{ modelValue: string | null }>()

const emit = defineEmits<{
    (e: 'update:model-value', value: string | number | null): void
}>()

function inputChanged(value: string | null) {
    emit('update:model-value', value ? formatTelefonNumber(value) : null)
}
</script>

<template>
    <kp-textfield :model-value="modelValue" v-bind="$attrs" @update:model-value="inputChanged" icon-type="tel">
    </kp-textfield>
</template>
